import { signInWithPopup, signInWithRedirect, GoogleAuthProvider, getRedirectResult } from 'firebase/auth';
import { auth } from '../firebase';

// Detect if user is on mobile device
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// Detect if user is on iOS Safari
export const isIOSSafari = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent);
};

// Check if popup is supported
export const isPopupSupported = () => {
  // Check if we're in a mobile environment or if popups are blocked
  if (isMobileDevice()) {
    return false;
  }
  
  // Test popup support
  try {
    const popup = window.open('', '_blank', 'width=1,height=1');
    if (popup) {
      popup.close();
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

// Simple Google sign in
export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  
  try {
    // Always use popup for simplicity
    const result = await signInWithPopup(auth, provider);
    return { success: true, result, method: 'popup' };
  } catch (error) {
    console.error('Authentication error:', error);
    throw new Error('Sign-in failed. Please try again.');
  }
};

// Simple redirect result handler
export const handleRedirectResult = async () => {
  try {
    const result = await getRedirectResult(auth);
    if (result) {
      return { success: true, result };
    }
    return { success: false };
  } catch (error) {
    console.error('Redirect result error:', error);
    return { success: false, error };
  }
};

// Wait for authentication state to be ready
export const waitForAuthReady = (maxWaitTime = 10000) => {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();
    
    const checkAuth = () => {
      if (auth.currentUser) {
        resolve(auth.currentUser);
      } else if (Date.now() - startTime > maxWaitTime) {
        reject(new Error('Authentication timeout'));
      } else {
        setTimeout(checkAuth, 100);
      }
    };
    
    checkAuth();
  });
};
